import { useState } from "react";
import { Card } from "../../../components/base/Card";
import { Button } from "../../../components/base/Button";
import { Modal } from "../../../components/base/Modal";
import { Drawer } from "../../../components/base/Drawer";
import { useConfirm } from "../../../context/ConfirmContext";
import { useToast } from "../../../context/ToastContext";
import { TextField } from "../../../components/base/TextField";

export function OverlaysSection() {
  const confirm = useConfirm();
  const toast = useToast();
  const [modalOpen, setModalOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const triggerToast = (variant: "success" | "error" | "warning" | "info") => {
    const map = {
      success: () => toast.success("Record saved", "The collection entry was saved to the ledger."),
      error: () => toast.error("Save failed", "Unable to reach the server. Check your connection."),
      warning: () => toast.warning("Overdue reminder", "3 members are overdue for this group."),
      info: () => toast.info("Export ready", "Your CSV export has been generated."),
    };
    map[variant]();
  };

  const handleDelete = async () => {
    const ok = await confirm({
      title: "Delete this member?",
      message: "This permanently removes the member from the group. Their collection history will also be deleted.",
      confirmLabel: "Delete member",
      destructive: true,
      dangerText: "This action cannot be undone.",
    });
    if (ok) toast.success("Member deleted", "The member was removed successfully.");
  };

  const handleConfirm = async () => {
    const ok = await confirm({
      title: "Record this collection?",
      message: "You are about to record a ₹1,00,000.00 collection for Aarav Mehta in group Laxmi-12.",
      confirmLabel: "Record collection",
    });
    if (ok) toast.success("Collection recorded", "The amount has been added to the ledger.");
  };

  return (
    <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
      <Card title="Feedback — toasts">
        <div className="flex flex-wrap gap-2">
          <Button variant="secondary" size="sm" onClick={() => triggerToast("success")} icon={<i className="ri-checkbox-circle-line" />}>
            Success
          </Button>
          <Button variant="danger" size="sm" onClick={() => triggerToast("error")} icon={<i className="ri-close-circle-line" />}>
            Error
          </Button>
          <Button size="sm" variant="outline" onClick={() => triggerToast("warning")} icon={<i className="ri-error-warning-line" />}>
            Warning
          </Button>
          <Button size="sm" variant="outline" onClick={() => triggerToast("info")} icon={<i className="ri-information-line" />}>
            Info
          </Button>
        </div>
      </Card>

      <Card title="Overlays — modal, drawer, confirm">
        <div className="flex flex-wrap gap-2">
          <Button size="sm" variant="secondary" onClick={() => setModalOpen(true)} icon={<i className="ri-window-line" />}>
            Open modal
          </Button>
          <Button size="sm" variant="secondary" onClick={() => setDrawerOpen(true)} icon={<i className="ri-side-bar-line" />}>
            Open drawer
          </Button>
          <Button size="sm" variant="outline" onClick={handleConfirm} icon={<i className="ri-question-line" />}>
            Confirm dialog
          </Button>
          <Button size="sm" variant="danger" onClick={handleDelete} icon={<i className="ri-delete-bin-line" />}>
            Destructive confirm
          </Button>
        </div>
      </Card>

      <Modal open={modalOpen} onClose={() => setModalOpen(false)} title="Add collection" description="Enter the details for this collection entry." size="md">
        <div className="space-y-4">
          <TextField label="Member name" placeholder="Search or enter member…" />
          <TextField label="Amount" placeholder="0.00" />
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={() => setModalOpen(false)}>Cancel</Button>
            <Button onClick={() => { setModalOpen(false); toast.success("Collection added", "The entry was saved."); }}>Save</Button>
          </div>
        </div>
      </Modal>

      <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)} title="Member details" description="Quick view / quick edit" size="md">
        <div className="space-y-4">
          <TextField label="Full name" defaultValue="Aarav Mehta" />
          <TextField label="Phone" defaultValue="+91 98100 12345" />
          <TextField label="Email" defaultValue="aarav@example.com" />
          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={() => setDrawerOpen(false)}>Close</Button>
            <Button onClick={() => { setDrawerOpen(false); toast.success("Saved", "Member details updated."); }}>Save changes</Button>
          </div>
        </div>
      </Drawer>
    </div>
  );
}